import React from 'react';
import { withStyles, Button, CircularProgress } from '@material-ui/core';

const styles = (theme) => ({
  actionContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: 32
  },
  actionButton: {
    textTransform: 'none',
    marginLeft: 12,
    minWidth: 92,
    marginRight: 0,
    '&$actionButtonDisabled': {
      backgroundColor: theme.HeaderSelectedText
    },
    '&$actionOutlineDisabled': {
      borderColor: theme.iconColor,
      color: theme.iconColor
    }
  },
  actionButtonDisabled: {
    backgroundColor: theme.HeaderSelectedText
  },
  actionOutlineDisabled: {},
  circularProgress: {
    color: 'white'
  }
});

const Action = ({
  onClose,
  classes,
  onConfirm,
  isNewLocation,
  locationUpdateInProgress,
  locationMappingId,
  submitButtonLabel
}) => {
  return (
    <div className={classes.actionContainer}>
      <Button
        variant="outlined"
        color="primary"
        size="small"
        onClick={() => onClose({isDataSaved: false, locationMappingId})}
        classes={{ root: classes.actionButton }}
        id="closeButton">
        Cancel
      </Button>
      <Button
        variant="contained"
        color="primary"
        size="small"
        type="submit"
        onClick={onConfirm}
        classes={{
          root: classes.actionButton,
          disabled: classes.actionButtonDisabled
        }}
        id={isNewLocation ? 'addLocationMapping' : 'updateLocationMapping'}>
        {locationUpdateInProgress ? (
          <CircularProgress size={16} classes={{ root: classes.circularProgress }} />
        ) : (
          submitButtonLabel
        )}
      </Button>
    </div>
  );
};

export default withStyles(styles)(Action);
